// extracted by css-extract-rspack-plugin
export default {"apkLink__downloadButtonContainer":"apkLink__downloadButtonContainer__IXguM","apkLink__progress":"apkLink__progress__jjPcf"};